import React from "react";
import {ButtonGroup, OverlayTrigger, Tooltip} from "react-bootstrap";
import SelectList from "../SelectList.jsx";
import {useIstSchmal} from "./format.js";
import {TOOLTIP_POPPER_CONFIG} from "./tooltipConfig.js";

export const ANSICHTEN = [
    {wert: "wunsch_zusage", label: "Wunsch / Zusage", hilfe: "Zeigt in jeder Zelle zwei Zahlen übereinander: oben die Wunschmenge, darunter die Zusage."},
    {wert: "wunsch", label: "Wunsch", hilfe: "Zeigt nur die gewünschte Menge je Zelle."},
    {wert: "zusage", label: "Zusage", hilfe: "Zeigt nur die von Cosmos zugesagte Menge je Zelle."},
    {wert: "geliefert", label: "Geliefert", hilfe: "Zeigt nur die tatsächlich gelieferte Menge je Zelle."},
    {wert: "vorschlag_neu", label: "Neuer Vorschlag", hilfe: "Zeigt nur die Menge aus dem Block „NEW - POSSIBLE ORDER“ je Zelle."},
];

/**
 * Ansichtsumschalter der Lieferplan-Zellen (AP7 B, PLAN.md Abschnitt 5) -
 * eigene Knopfgruppe statt eines Auswahlfelds, jede Option mit eigenem
 * Erklär-Tooltip. Standard ist "Wunsch / Zusage" (zwei Zahlen übereinander).
 * Bei schmalen Bildschirmen (390 px) brach die fünfteilige Knopfgruppe
 * uneinheitlich um (Sichtprüfung 1) - dort tritt eine eigene Auswahlliste an
 * ihre Stelle (SelectList statt natives <select>, Hausregel).
 */
export default function AnsichtSchalter({value, onChange}) {
    const schmal = useIstSchmal(576);

    if (schmal) {
        return (
            <SelectList
                value={value}
                options={ANSICHTEN.map((a) => ({value: a.wert, label: a.label}))}
                onChange={onChange}
                size="sm"
                ariaLabel="Ansicht der Lieferplan-Zellen"
                style={{minWidth: 180}}
            />
        );
    }

    return (
        <ButtonGroup size="sm">
            {ANSICHTEN.map((a) => (
                <OverlayTrigger flip popperConfig={TOOLTIP_POPPER_CONFIG} key={a.wert} placement="top" overlay={<Tooltip id={`cosmos-ansicht-${a.wert}`}>{a.hilfe}</Tooltip>}>
                    <button
                        type="button"
                        className={`btn btn-outline-secondary${value === a.wert ? " active" : ""}`}
                        aria-pressed={value === a.wert}
                        onClick={() => onChange(a.wert)}
                    >
                        {a.label}
                    </button>
                </OverlayTrigger>
            ))}
        </ButtonGroup>
    );
}
